export default __webpack_public_path__ + "loader-eclipse.gif?c2d2f6f49bf001342127f71348c4446e";